import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom"
import PayScreen from "./pay.screen"
import PayPreviewScreen from "./pay-preview.screen"
import NotFoundScreen from "@/not-found.screen"
import ErrorScreen from "@/error.screen"
import * as Sentry from "@sentry/react"
import PayWithBalanceScreen from "./with-balance/pay-with-balance.screen"
import PayWithExternalScreen from "./pay-with-external.screen"
import HomeScreen from "./home.screen"

const router = createBrowserRouter(
  [
    {
      element: (
        <Sentry.ErrorBoundary fallback={<ErrorScreen />}>
          <Outlet />
        </Sentry.ErrorBoundary>
      ),
      children: [
        {
          path: "/:shortId",
          element: <PayScreen />,
          children: [
            {
              path: "",
              element: <HomeScreen />,
            },
            {
              path: "/:shortId/pay-with-external",
              element: <PayWithExternalScreen />,
            },
            {
              path: "/:shortId/pay-with-balance",
              element: <PayWithBalanceScreen />,
            },
          ],
        },
        {
          path: "/preview",
          element: <PayPreviewScreen />,
        },
        {
          path: "*",
          element: <NotFoundScreen />,
        },
      ],
    },
  ],
  {
    basename: "/p",
  },
)

export default function Routes() {
  return <RouterProvider router={router} />
}
